const fb = require("../firebase.js");

export default {
  namespaced: true,
  actions: {
    toggleLove({}, params) {
      fb.db.collection("lovers").doc(params.itemId).collection("lovers").doc(fb.firebase.auth().currentUser.uid).get().then((doc) => {
        if (doc.exists) {
          fb.db.collection("lovers").doc(params.itemId).collection("lovers").doc(fb.firebase.auth().currentUser.uid).delete()
        } else {
          let lover = {
            createdAt: fb.firebase.firestore.Timestamp.now(),
            target: params.target
          }
          if (params.parentId) lover.parentId = params.parentId;
          if (params.deep) lover.deep = params.deep;
          if (params.self.profilePictureUrl) lover.profilePictureUrl = params.self.profilePictureUrl;
          if (params.self.nickname) lover.nickname = params.self.nickname;
          fb.db.collection("lovers").doc(params.itemId).collection("lovers").doc(fb.firebase.auth().currentUser.uid).set(lover)
        }
      })
    },
  }
}